import { CustomRouteConfig } from 'app/types/routes';

const routeConfig = {
  authCallback: {
    path: 'auth-callback',
  },
  public: {
    path: 'public',
    routes: {
      login: {
        path: 'login',
        routes: {
          callback: {
            path: 'callback',
          },
        },
      },
      registration: {
        path: 'registration',
        routes: {
          callback: {
            path: 'callback',
          },
        },
      },
      forgotPassword: {
        path: 'forgot-password',
        routes: {
          submitEmail: {
            path: 'submit-email',
          },
          submitCode: {
            path: 'submit-code',
          },
          setPassword: {
            path: 'set-password',
          },
        },
      },
      reports: {
        path: 'reports',
      },
      analyticsReports: {
        path: 'analytics-reports',
        routes: {
          view: {
            path: ':id/view',
          },
        },
      },
      analyticsExports: {
        path: 'analytics-exports',
        routes: {
          view: {
            path: ':id/view',
          },
        },
      },
      pdfReports: {
        path: 'pdf-reports',
        routes: {
          insightsPagePerformance: {
            path: 'insights-page-performance',
            routes: {
              overview: {
                path: 'overview',
              },
              currentSelection: {
                path: 'current-selection',
              },
            },
          },
          insightsPostsPerformance: {
            path: 'insights-posts-performance',
          },
          insightsCompetitionAnalysis: {
            path: 'insights-competition-analysis',
          },
          reports: {
            path: ':id/view',
          },
          insightsLite: {
            path: 'insights-lite',
          },
        },
      },
      freeTools: {
        path: 'free-tools',
        routes: {
          bestTimeToPost: {
            path: 'best-time-to-post',
          },
          instagramFeedPreview: {
            path: 'instagram-feed-preview',
          },
          linkShortener: {
            path: 'url-shortener',
          },
          utmTagBuilder: {
            path: 'utm-tag-builder',
          },
          aiCaptionGenerator: {
            path: 'ai-caption-generator',
          },
          aiHashtagGenerator: {
            path: 'ai-hashtag-generator',
          },
          aiUsernameGenerator: {
            path: 'ai-username-generator',
          },
          aiBioGenerator: {
            path: 'ai-bio-generator',
          },
          aiCommentGenerator: {
            path: 'ai-comment-generator',
          },
          tiktokFeedPreview: {
            path: 'tiktok-feed-preview',
          },
          youtubeFeedPreview: {
            path: 'youtube-feed-preview',
          },
          pinterestFeedPreview: {
            path: 'pinterest-feed-preview',
          },
        },
      },
      resetPassword: {
        path: 'reset-password',
      },
      post: {
        path: 'post',
      },
    },
  },
  embed: {
    path: 'embed',
    routes: {
      cancelSubscription: {
        path: 'cancel-subscription',
      },
    },
  },
  onboarding: {
    path: 'onboarding',
    routes: {
      initSetupAccount: {
        path: 'setup-account',
      },
      connectProfiles: {
        path: 'connect-profiles',
      },
    },
  },
  dashboard: {
    path: 'dashboard',
  },
  posts: {
    path: 'posts',
    routes: {
      calendar: {
        path: 'calendar',
      },
      kanban: {
        path: 'kanban',
      },
      grid: {
        path: 'grid',
      },
      list: {
        path: 'list',
      },
    },
  },
  insights: {
    path: 'insights',
    routes: {
      postsPerformance: {
        path: 'posts-performance',
      },
      pagePerformance: {
        path: 'page-performance',
      },
      competitionAnalysis: {
        path: 'competition-analysis',
      },
      performanceHub: {
        path: 'performance-hub',
      },
    },
  },
  insightsLite: {
    path: 'insights-lite',
  },
  notifications: {
    path: 'notifications',
    routes: {
      history: {
        path: 'history',
      },
    },
  },
  settings: {
    path: 'settings',
    routes: {
      authorization: {
        path: 'authorization',
      },
      billing: {
        path: 'billing',
        routes: {
          return: {
            path: 'return',
          },
        },
      },
      users: {
        path: 'users',
      },
      security: {
        path: 'security',
      },
      personal: {
        path: 'personal',
      },
      notifications: {
        path: 'notifications',
      },
      devices: {
        path: 'devices',
      },
    },
  },
  verifyEmail: {
    path: 'verify-email',
  },
  aiContent: {
    path: 'ai-content',
  },
  brandHub: {
    path: 'brand-hub',
  },
  mediaLibrary: {
    path: 'media-library',
    routes: {
      album: {
        path: ':albumId',
      },
      trash: {
        path: 'trash',
      },
    },
  },
  reports: {
    path: 'reports',
    routes: {
      new: {
        path: 'new',
      },
      my: {
        path: 'my',
      },
      edit: {
        path: ':id/edit',
      },
    },
  },
  approvals: {
    path: 'approvals',
    routes: {
      posts: {
        path: 'posts',
      },
    },
  },
  bio: {
    path: 'bio',
    routes: {
      create: {
        path: 'create',
      },
      editor: {
        path: ':id/edit',
      },
      analytics: {
        path: ':id/analytics',
      },
    },
  },
  analytics: {
    path: 'analytics',
    routes: {
      overview: {
        path: 'overview',
      },
      performance: {
        path: 'performance',
      },
      content: {
        path: 'content',
      },
      competitionAnalysis: {
        path: 'competition-analysis',
      },
      reports: {
        path: 'reports',
        routes: {
          create: {
            path: 'create',
          },
          edit: {
            path: ':reportId/edit',
          },
        },
      },
    },
  },
} satisfies CustomRouteConfig;

export default routeConfig;
